import React, { useContext, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import './navbarlaboratorio.css';
import { AuthContext } from '../../Context/auth';
import { Navbar, Container, Row, Col, Button, Offcanvas } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import localImage from './lab.jpeg';
import localImage1 from './lab.jpeg';
//import localImage2 from './login.jpg';
//import localImage3 from './Laboratorio.jpeg';
//import localImage4 from './BOTAO-GEOCONTROLE.jfif';
import marcageo from './GEOPLUS1.png';
// import Frase from './bemvindo.png';
import axios from 'axios'; // npm i axios
import Conexao from '../../Config/conexao';
import { FaGlobe, FaInstagram, FaLinkedin } from 'react-icons/fa';
import styles from './StyledButton.module.css';
function NavbarLaboratorio() {

  const { setLogado } = useContext(AuthContext);

  function Logout() {
    setLogado(false);
    localStorage.removeItem("logado");
  }


  const [showSidebar, setShowSidebar] = useState(false);
  const [showSecondSidebar, setShowSecondSidebar] = useState(false);
  const [showSobreSidebar, setShowSobreSidebar] = useState(false);
  const [showGeocontroleSidebar, setShowGeocontroleSidebar] = useState(false);
  const [liClicked, setLiClicked] = useState(false);
  const [liClickedcor, setLiClickedcor] = useState(false);
  const [liClicked1, setLiClicked1] = useState(false);
  const [liClicked2, setLiClicked2] = useState(false);
  const [liClicked3, setLiClicked3] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(localImage);
  const [sucesso, setSucesso] = useState('');

  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');

  const images = [
    localImage,
    localImage1,
    //localImage2,
    //localImage3,
    //localImage4,
  ];

  const handleCloseSidebar = () => {
    setShowSidebar(false);
    setBackgroundImage(images[0])
  }

  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    setBackgroundImage(images[index]);

  }

  const handleLiClick = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked(true);
    handleShowSecondSidebar();
    console.log(backgroundImage);
    handleCloseSobreSidebar(index); setLiClicked1(false);
    handleCloseGeocontroleSidebar(index); setLiClicked3(false);
  };

  const handleCloseSecondSidebar = () => {
    setShowSecondSidebar(false);
    setBackgroundImage(images[1])
  }

  const handleShowSecondSidebar = () => {
    setShowSecondSidebar(true);
    setBackgroundImage(images[1])
  }

  const handleCloseSobreSidebar = (index) => {
    setShowSobreSidebar(false);
    setBackgroundImage(images[index])
  }

  const handleLiClickSobre = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked1(true);
    setShowSobreSidebar(true);
    console.log(backgroundImage);
    handleCloseSecondSidebar(index); setLiClicked(false);
    handleCloseGeocontroleSidebar(index); setLiClicked3(false);
  };

  const handleCloseGeocontroleSidebar = (index) => {
    setShowGeocontroleSidebar(false);
    setBackgroundImage(images[index])
  }

  const handleLiClickGeocontrole = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked3(true);
    setShowGeocontroleSidebar(true);
    console.log(backgroundImage);
    handleCloseSecondSidebar(index); setLiClicked(false);
    handleCloseSobreSidebar(index); setLiClicked1(false);
  };

  const togglePasswordVisibility = () => setPasswordShown(!passwordShown);

  function alterarEmail(event) {
    setUsuario(event.target.value);
  }

  function alterarSenha(event) {
    setSenha(event.target.value);
  }



  function SalvaUser() {
    localStorage.usuario = document.getElementById("floatingInput").value;
  }

  return (
    <div className="home">

      <div className="bannerNav" style={{ backgroundImage: `url(${backgroundImage})` }}>

        <Container>
          <div>

            <div className="text-center">
              {showSidebar === false ? <div className="image-wrapper">
                {/* <img src={marcageo} className="image-adjust" alt="Descrição" />
                <img src={Frase} className="image-adjust" alt="Descrição" /> */}
              </div> : null}
            </div>

          </div>
        </Container>
        <div className="sidebar-button">
          <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
            <div className="icon-container">
              <i className="bi bi-list icon-circle"></i>
            </div>
          </Button>
        </div>

      </div>

      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      {/* Sidebar Login */}
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
        <div className="offcanvas-header">
         
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
              <Link to="/app/home" style={{ textDecoration: 'none' }}>
                <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
            </li>
            {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>



      <div className="green-bar">
        <div className="button-grid" >

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', marginTop: '3%' }}>

            <button class="btn btn-secondary dropdown-toggle btn-block hover-effect" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}>Ensaios</button>

            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style={{ backgroundColor: '#072421', width: '20%', height: '150px', fontSize: '20px' }}>

              <li className="nav-link">
                <Link to='/app/Compactacao' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                  Compactação
                </Link>
              </li>
{/* 
              <li><a class="dropdown-item btn-block hover-effect" href="#" style={{ color: '#ffffff', backgroundColor: '#072421', display: 'block' }}>Another action</a></li>

              <li><a class="dropdown-item btn-block hover-effect" href="#" style={{ color: '#ffffff', backgroundColor: '#072421', display: 'block' }}>Something else here</a></li> */}
            </ul>


            <button className="btn btn-success mt-4 hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}>  <Link to='/app/CadastroAmostra' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Cadastro de Amostra</Link></button>

            <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/Programacao' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Programação</Link></button>

          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', marginTop: '-7%' }}>

            <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/QuadroResumo' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Quadro de Resumo</Link></button>


            <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/relatorio-sequencial' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Relatorio Sequencial</Link></button>

           

          </div>


        </div>


      </div>
      <div className="footer">
        <img src={marcageo} className="image-adjustLab" />
      </div>
    </div>
  );
}

export default NavbarLaboratorio;